// import CashFlows from 'app/collections/cash_flows';
import ApiMode from 'app/models/api_mode';
import CashFlowReport from 'app/models/cash_flow_report';
import DateRange from 'app/models/date_range';
import UTCOffsetSelection from 'app/models/utc_offset_dropdown_selection';

import Base from 'app/views/base';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import RequestReportView from 'app/views/request_report_view'
import SelectorView from 'app/views/selector_view';

// import { List as ListView, Heading } from 'app/components/list/list';
import { Heading } from 'app/components/list/list';

import tmpl from './template';

export const PAGE_SIZE = 7;
export const MIN_DATERANGE_DATE = '2016-11-01';

export const buildHeadings = () => {
  return [
    new Heading({
      property: 'date',
      display: 'Date',
      xsSize: 2,
      smSize: 2,
    }),
    new Heading({
      text: m => m.get('start_balance') || '--',
      display: 'Start Balance',
      wrapperClass: 'text-right',
      xsSize: 2,
      smSize: 2,
    }),
    new Heading({
      property: 'total_fees',
      display: 'Total Fees',
      wrapperClass: 'text-right',
      xsSize: 3,
      smSize: 3,
    }),
    new Heading({
      text: m => {
        let totalDebitsStr = m.get('total_debits');
        if (Number(totalDebitsStr.replace(/\$|,/g, '')) > 0) totalDebitsStr = `+${totalDebitsStr}`;
        return totalDebitsStr;
      },
      display: 'Total Debits',
      wrapperClass: m => {
        const classes = ['text-right'];
        if (m && Number(m.get('total_debits').replace(/\$|,/g, '')) > 0) classes.push('text-green');
        return classes.join(' ');
      },
      xsSize: 3,
      smSize: 3,
    }),
    new Heading({
      text: m => m.get('end_balance') || '--',
      display: 'End Balance',
      wrapperClass: 'text-right',
      xsSize: 2,
      smSize: 2,
    }),
  ];
};

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'cash-flow',

  initialize() {
    this.apiMode = new ApiMode({ mode: 'production' });
    this.dateRange = new DateRange({});
    this.utcOffsetSelection = new UTCOffsetSelection();
    // this.collection = new CashFlows([], { dateRange: this.dateRange, utcOffsetSelection: this.utcOffsetSelection, pageSize: PAGE_SIZE });
    this.dropdownSelections = [ this.utcOffsetSelection ];

    // this.listenTo(this.collection, 'update', this.render);
    // this.listenTo(this.dateRange, 'change', this.collection.resetToFirstPage.bind(this.collection));
    // this.dropdownSelections.forEach(dropdownSelection => {
    //   this.listenTo(dropdownSelection, 'change', this.collection.resetToFirstPage.bind(this.collection));
    // });

    this.addSubview('datePickers', '#cash_flow_daterange_pickers', new DatepickerRangeView({
      model: this.dateRange, minDate: MIN_DATERANGE_DATE,
    }));
    this.addSubview('utcOffsetSelector', '#utc_offset_selector', new SelectorView({ model: this.utcOffsetSelection }));
    this.addSubview('requestCashFlowReport', '#request_cash_flow_report', new RequestReportView({
      // collection: this.collection, ReportClass: CashFlowReport, dateRange: this.dateRange,
      ReportClass: CashFlowReport, dateRange: this.dateRange,
      apiMode: this.apiMode, dropdownSelections: this.dropdownSelections,
    }));
    // this.addSubview('cashFlowList', '#cash_flow_list', new ListView({
    //   headings: buildHeadings(),
    //   collection: this.collection,
    //   noResultsMessage: 'No Cash Flow activity found.',
    // }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/cash_flow/index.js